module.exports = __webpack_public_path__ + "img/testcard.be849790.svg";